import React from 'react';
import { PracticeQuizSession } from '../components/PracticeQuizSession';
import { ModuleHeader } from '../components/ModuleHeader';
import { AdUnit } from '../components/AdUnit';
import { CheckCircle2 } from 'lucide-react';

interface StudyQuizProps {
  defaultTopic?: string;
}

export const StudyQuiz: React.FC<StudyQuizProps> = ({ defaultTopic }) => {
  const isMissedBank = defaultTopic === 'Missed Questions';

  return (
    <div className="animate-fade-in max-w-7xl mx-auto">
      <ModuleHeader 
        icon={CheckCircle2}
        title={defaultTopic === 'Missed Questions' ? "My Mistakes List" : "Practice Quizzes"}
        description={defaultTopic === 'Missed Questions' 
          ? "Practice the questions you missed before. Answer them correctly to clear them from this list." 
          : "Test your knowledge with quick quizzes on any topic. We explain the answers right away so you can learn quickly."}
        badge="Active Help"
        color={defaultTopic === 'Missed Questions' ? "rose" : "medical"}
      />
      
      <PracticeQuizSession defaultTopic={defaultTopic} />
    </div>
  );
};